import { render, staticRenderFns } from "./disbindConfirm.vue?vue&type=template&id=55155e15&scoped=true"
import script from "./disbindConfirm.vue?vue&type=script&lang=ts"
export * from "./disbindConfirm.vue?vue&type=script&lang=ts"
import style0 from "./disbindConfirm.vue?vue&type=style&index=0&id=55155e15&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55155e15",
  null
  
)

export default component.exports